<template>
  <div :class="classes">
    <pt-page-title :title="isEdit?'编辑':'发布'+'消息'"></pt-page-title>
    <table>
         <pt-form-list-item label="消息标题：" required>
             <wt-input v-model="formValue.title"  data-vv-as="消息标题" name="name"  v-validate="'required'"></wt-input>
         </pt-form-list-item>
         <pt-form-list-item label="消息内容：" required>
             <wt-input v-model="formValue.content" :autosize="{minRows:4,maxRows:8}" type="textarea"  data-vv-as="消息内容" name="name"  v-validate="'required'"></wt-input>
         </pt-form-list-item>
         <pt-form-list-item label="发布对象：" required>
             <wt-radio v-model="sendTo" :radios="sendToRadios"  data-vv-as="发布对象" name="name"  v-validate="'required'"></wt-radio>
         </pt-form-list-item>
         <pt-form-list-item label="选择用户：" required  v-if="isSelect">
             <wt-input  data-vv-as="用户" v-model="selectUserList.length" name="name"  v-validate="'required'" style="display:none"></wt-input>
             <el-button type="primary" @click="selectUser">选择用户</el-button>
                <div :class="$style['select-user-name']" v-if="selectUserList&&selectUserList.length">
                    <span>已选择 {{firstUserName}} {{selectUserList.length > 1 ? ('等'  +selectUserList.length +'位用户...') : ''}}</span>
                    <el-button type="text" @click="viewUser">查看</el-button>
                </div>
         </pt-form-list-item>
    </table>
    <el-dialog :visible.sync="is_dialog" :title="dialog_title" @close="closeDialog" class="user-dialog">
        <select-view-user v-if="is_view_user" :pageSize="5"  :userIds="formValue.sendTo" parameter="userLoginList" filed="userLogin" @viewUserListDelete="viewUserListDelete" :pageEdit="true"  @close="closeDialog"></select-view-user>
        <select-for-user v-if="is_select_user" :pageSize="5"  @selectUsersSubmit="selectUsersSubmit" :selectedUser="selectUserList"  @close="closeDialog"></select-for-user>
    </el-dialog>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { sendToRadio } from '../notice-option'
import selectViewUser from 'cps/customer-manage/select-view-user'
import selectForUser from 'cps/customer-manage/select-for-user'
// 组件class前缀
const prefixCls = 'pt-notice-form'
export default {
  name: 'pt-notice-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 是否需要选择用户
    isSelect () {
      return this.sendTo !== 'all'
    },
    is_dialog: {
      get: function () {
        return this.is_select_user || this.is_view_user
      },
      set: function (val) {
        this.is_select_user = val
        this.is_view_user = val
      }
    }
  },
  components: {
    selectForUser,
    selectViewUser
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  watch: {
    selectUserList: {
      handler: function (val) {
        if (val) {
          this.formValue.sendTo = []
          val.forEach(item => {
            this.formValue.sendTo.push(item.userLogin ? item.userLogin : item)
          })
        }
      },
      deep: true
    }
  },
  data () {
    return {
      formValue: {
      },
      sendToRadios: sendToRadio,
      sendTo: 'all',
      is_select_user: false,
      is_view_user: false,
      dialog_title: '',
      firstUserName: '',
      selectUserList: []
    }
  },
  methods: {
    viewUserListDelete (val) {
      this.selectUserList = JSON.parse(JSON.stringify(val))
    },
    closeDialog () {
      this.is_select_user = false
      this.is_view_user = false
    },
    selectUser () {
      this.is_select_user = true
      this.dialog_title = '选择用户'
    },
    viewUser () {
      this.is_view_user = true
      this.dialog_title = '查看用户'
    },
    selectUsersSubmit (val) {
      this.is_select_user = false
      let firstUserName = ''
      for (let i in val) {
        if (val[i].fullName) {
          firstUserName = val[i].fullName
          break
        }
      }
      this.selectUserList = val
      this.firstUserName = firstUserName
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
<style lang="less">
.pt-notice-form{
    table{
        max-width: 500px;
    }
    .user-dialog{
        :global
        .el-dialog{
        width: 70%;
        min-width:1100PX;
        max-width:1200Px;
    }
    :global
    .el-dialog__body{
     padding: 0 20px 30px;
    }
    }
}
</style>
